var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayMeteredConnectionWarning
    ? _c(
        "KModal",
        {
          attrs: {
            title: _vm.$tr("modalTitle"),
            submitText: _vm.coreString("continueAction"),
            submitDisabled: _vm.loading,
          },
          on: { submit: _vm.submit },
        },
        [
          _c(
            "div",
            [
              _c("p", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$tr("modalDescription")) + "\n    "
                ),
              ]),
              _c(
                "KRadioButtonGroup",
                [
                  _c("KRadioButton", {
                    staticClass: "radio-button",
                    attrs: {
                      label: _vm.$tr("doNotUseMetered"),
                      buttonValue: _vm.Options.DO_NOT_USE_METERED,
                      disabled: _vm.loading,
                    },
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                  _c("KRadioButton", {
                    staticClass: "radio-button",
                    attrs: {
                      label: _vm.$tr("useMetered"),
                      buttonValue: _vm.Options.USE_METERED,
                      disabled: _vm.loading,
                    },
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }